import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventario-inventariado',
  templateUrl: './lista.component.html'
})

export class InventariadoComponent{
  tamano = document.body.clientHeight;
  datos = [];
  cargando = false;

}